import { OfficeGroupEntity } from "../../../entities";
export const OfficeGroupRegistrationRequestSchema = OfficeGroupEntity.schema.pick({
    name: true,
    officeIds: true,
});
export const OfficeGroupInitRegistrationRequestSchema = OfficeGroupEntity.schema.pick({
    id: true,
    name: true,
    officeIds: true,
    version: true,
});
export const OfficeGroupUpdateRequestSchema = OfficeGroupEntity.schema.pick({
    name: true,
    officeIds: true,
    version: true,
});
// export const OfficeGroupUpdateOrderRequestSchema = OfficeGroupsOrder.schema.partial({
//   version: true,
// });
// export type OfficeGroupUpdateOrderRequest = z.infer<
//   typeof OfficeGroupUpdateOrderRequestSchema
// >;
//# sourceMappingURL=office-group-request.js.map